import React from "react";
import Reveal, { Eyebrow } from "../common/Reveal";
import { protocols } from "../../mock";

export default function Protocols() {
  return (
    <section className="bg-lybl-cream py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center">
          <Reveal><Eyebrow>{protocols.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-lybl-ink text-balance">{protocols.title}</h2></Reveal>
          <Reveal delay={140}><p className="mt-5 max-w-2xl mx-auto text-lybl-muted text-lg">{protocols.subtitle}</p></Reveal>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {protocols.items.map((p, i) => (
            <Reveal key={p.title} delay={i * 80} className={i === 0 ? "lg:row-span-2" : ""}>
              <div className="group h-full overflow-hidden rounded-3xl bg-white ring-1 ring-black/5 hover:shadow-xl transition-shadow">
                <div className={`overflow-hidden ${i === 0 ? "h-64 lg:h-72" : "h-48"}`}>
                  <img src={p.image} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <span className="text-[12px] font-semibold uppercase tracking-wider text-lybl-rust">{p.tag}</span>
                  <h3 className="mt-2 font-serif text-2xl text-lybl-ink">{p.title}</h3>
                  <p className="mt-3 text-[15px] text-lybl-muted leading-relaxed">{p.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
